import { render, staticRenderFns } from "./CameraMenu.vue?vue&type=template&id=6bb4224e&scoped=true"
import script from "./CameraMenu.vue?vue&type=script&lang=js"
export * from "./CameraMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4224e",
  null
  
)

export default component.exports